import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const loadRoles = async () => {
  const response = await Api.get('roles?per_page=500');
  if (response.status === 200) {
    return response.data.data.map(t => ({
      label: `${t.name}`,
      value: t.id,
    }));
  }
  return [];
};

const RolesSelector = ({
  onChanged,
  selectedId,
  isMulti,
}) => {
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    loadRoles().then(result => setRoles(result));
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = roles.find(x => x.value === selectedId);
  }
  return (
    <Select
      options={roles}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select a Role"
      isMulti={isMulti}
    />
  );
};

RolesSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

RolesSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: 0,
};

export default RolesSelector;
